<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
                ref="terminalAudit"
                :visible="infoIsShow"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">投诉人信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">所属机构：</span>
                        <span>{{dialogData.data.agent_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">代理人姓名：</span>
                        <span>{{dialogData.data.corporate_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">代理账户：</span>
                        <span>{{dialogData.data.phone}}</span>
                    </el-col>
                    <el-col :span="24" v-if="litigation_id">
                        <span class="labels">第{{add(dialogData.data.number_of_times)}}投诉</span>
                        <el-row>
                            <el-col :sm="12" :lg="6">
                                <el-result icon="success" title="成功提示" subTitle="请根据提示进行操作">
                                    <template slot="extra">
                                        <el-button type="primary" size="medium">返回</el-button>
                                    </template>
                                </el-result>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-form
                        label-position="top"
                        label-width="80px"
                >
                    <div class="title" v-if="!litigation_id">选择被投诉人</div>
                    <template v-if="!litigation_id">
                        <el-select v-model="auditForm.u_id" placeholder="请选择" style="width: 80%">
                            <el-option
                                    v-for="item in infoTable"
                                    :key="item.id"
                                    :label="`等级.${item.level} | ${item.real_name} | ${item.phone}]`"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </template>
                    <div class="title">客诉处理结束时间</div>
                    <el-date-picker
                            v-model="auditForm.date_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-value="date"
                            default-time="17:00:00"
                            placeholder="选择日期时间">
                    </el-date-picker>
                    <div class="title" v-if="!litigation_id">投诉金额<span style="color:red">[单位:元]</span></div>
                    <el-input v-model="auditForm.amount" placeholder="请输入打款金额" style="width: 130px;" v-if="!litigation_id"></el-input>
                    <div class="title">备注</div>
                    <tinymce v-model="auditForm.content" ref="editor" @getVal="getVal" />
                </el-form>
                <div style="margin-top:60px">
                    <el-button
                            @click="submit"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import tinymce from '../../components/Editor/Editor2'
export default {
    name: "FM_dealpunishinfo",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    data() {
        return {
            infoTable: [], //表格
            merchantTable: [],
            auditForm: {
                amount: "", // 处罚金额
                content: '', // 处罚详情
                m_id:this.dialogData.data.id, //商户id
                date_time:"",
                u_id:"",  //user_id
                litigation_id:this.dialogData.data.litigation_id,
            },
            loading: false,
            checked: true,
            activeName: '',
            litigation_id:this.dialogData.data.litigation_id,
            date:'',
        }
    },
    created() {
        this.setTime() // 设置默认时间
    },
    mounted() {
        // 查询对应用户 上级代理商/代理账户
        this.$api.post('user/all_merchant_user', {user_id:this.dialogData.data.user_id}, res => {
            if (res.code == 0) {
                this.merchantTable = res.data;
                //渲染结束后取消加载
                this.loading = false;
            } else {
                this.$message.error(res.msg);
                //渲染结束后取消加载
                this.loading = false;
            }
        });
        this.$api.post('user/all_superior_user', {user_id:this.dialogData.data.user_id}, res => {
            if (res.code == 0) {
                this.infoTable = res.data;
                //渲染结束后取消加载
                this.loading = false;
            } else {
                this.$message.error(res.msg);
                //渲染结束后取消加载
                this.loading = false;
            }
        });
    },
    methods: {
        getVal(val) {
            this.auditForm.content = val;
        },
        setTime() {
            var d = new Date();
            var year = d.getFullYear();      //年
            var month = d.getMonth()+1;       // 月
            var myDate = d.getDate();      //日
            var tttt = year + '-' + month + '-' + myDate+' 17:00:00'
            this.date = tttt;
        },
        // 提交处罚数据
        submit() { //提交
            console.log(this.dialogData.data);
            this.$api.post('merchant/addDeduction', this.auditForm, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        handleClose(ref) {
            this.$emit('infoClose', ref);
        },
        add(params){
            return parseInt(params)+1;
        }
    },
    components: {
        tinymce
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
</style>
